// This Type contains the state for the BMI. The variables represent the values needed to calculate the BMI.
// for future reference: age(years), height(cm), weight(kg)
export type BmiBlockState = {
  age?: number
  length?: number
  weight?: number

  gastricBand?: boolean
}

export const initialBmiBlockSTate: BmiBlockState = {
  age: undefined,
  length: undefined,
  weight: undefined,
  gastricBand: undefined,
}

export const bmiBlockStateUpdaters = {
  updateAge:
    (num: number) =>
    (blockState: BmiBlockState): BmiBlockState => ({
      ...blockState,
      age: num,
      gastricBand: undefined,
    }),
  updateWeight:
    (num: number) =>
    (blockState: BmiBlockState): BmiBlockState => ({
      ...blockState,
      weight: num,
      gastricBand: undefined,
    }),
  updateLength:
    (num: number) =>
    (blockState: BmiBlockState): BmiBlockState => ({
      ...blockState,
      length: num,
      gastricBand: undefined,
    }),
  updateBool:
    (bool: boolean, prop: string, depth: number) =>
    (blockState: BmiBlockState): BmiBlockState => ({
      ...blockState,
      gastricBand: depth < 1 ? undefined : blockState.gastricBand,
      [prop]: bool,
    }),
}
